enum PointTheme {
    club = 'club',
    plus = 'plus',
    kicks = 'kicks'
}

export default PointTheme;
